import { createApiHooks } from '@apis/next/common';
import { ZipcodeCity } from '@models/next/ZipcodeCity';
import { z } from 'zod';

export const zipcodeCityApis = createApiHooks('/zipcode-city', [
  {
    method: 'get',
    path: '/city/:zipcode',
    parameters: [
      {
        type: 'Path',
        name: 'zipcode',
        schema: z.string(),
      },
    ],
    response: ZipcodeCity.array(),
  },
  {
    method: 'get',
    path: '/zipcode/:city',
    parameters: [
      {
        type: 'Path',
        name: 'city',
        schema: z.string(),
      },
      {
        type: 'Query',
        name: 'enable_zh',
        schema: z.boolean().optional(),
      },
    ],
    response: ZipcodeCity.array(),
  },
]);
